import Address from '../entrypoints/src/admin/components/address';
import ManageableCards from '../entrypoints/src/admin/components/manageable_cards';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    new ManageableCards(this.element, {
      requiredFields: 'input.postal-code, input.address, input.number',
      initialize: ($card) => {
        Address.init({
          container: $card,
          input: $card.querySelector('.mask-postal-code'),
          actionButton: $card.querySelector('.find-address')
        })
      }
    });
  }
};